import axios from 'axios'
import Cookies from 'js-cookie';

const token = Cookies.get('snail_token');

const serviceAxios = axios.create({
  headers: {Authorization: token ? `bearer ${token}` : ''}
})

serviceAxios.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

serviceAxios.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.data
    } else {
      return Promise.reject(response)
    }
    // TODO 这里要做token失效判断跳转到登录页面 和后端沟通具体code值
  },
  (error) => {
    console.log(error)
    if (error.response && error.response.data) {
      if (error.response.data.error === 'forbidden' && error.response.data.message === '用户未登录') {
        Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_USERID');
        Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_NICKNAME');
        Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_PATH');
        Cookies.remove('snail_token');
        Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_MENU');
        window.location.href = '/login'
      }
    }
    return Promise.reject(error.response && error.response.data ? error.response.data : '')
  }
)

export default ({url, params, headers, method}) => {
  const option = {
    method: method || 'get',
    url
  };
  if (!method || method.toLowerCase() === 'get') {
    option.params = params;
  } else {
    option.data = params;
  }
  if (!!headers) {
    option.headers = headers;
  }
  return serviceAxios(option)
}